import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/login/";

const LoginApi = {
	get(forcedGebruikersnaam, forcedPoId, forcedEmail) {
		let headers;
		if (forcedGebruikersnaam && (forcedPoId || forcedEmail))
            headers = {
                accept: 'application/json',
                'SV-Voornaam': forcedGebruikersnaam.split(" ")[0],
				'SV-Naam': forcedGebruikersnaam.split(" ")[1],
				'SV-POID': forcedPoId,
				'SV-EMAIL': forcedEmail
            };
        else
            headers = {
                accept: 'application/json'
            };
		const serviceUrl = prependRoot(routePrefix + '/', getApiRoot());
		return axios.get(serviceUrl, {
			headers: headers
		});
	},
	validate(model) {
		const serviceUrl = prependRoot(routePrefix + '/validate', getApiRoot());
		return axios.put(serviceUrl, model,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	set(model) {
		const serviceUrl = prependRoot(routePrefix + '/set', getApiRoot());
		return axios.put(serviceUrl, model,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default LoginApi;